export class ListInventoryResourcesResponse {
    'resources';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resources",
            "baseName": "resources",
            "type": "Array<InventoryResource>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryResourcesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
